export default function DescripcionSitio() {
    return (
        <section className="pt-2">
            <div className="container-fluid pt-10 text-center">
                <h3 className="fs-5">Alvaro Santamaria Viajes y Turismo</h3>
                <p >es una agencia de viajes con más de 25 años de experiencia en el sector transportador y turístico. Somos una empresa ampliamente reconocida y consolidada a nivel local y regional.</p>
            </div>
        </section>
    )
}